import gql from 'graphql-tag';

import integrationEmailBodyFragment from '../fragments/integrationEmailBodyFragment';

export default gql`
  query integrationEmailBody(
    $integrationID: DokkioID!
    $remoteID: ID!
  ) {
    integrationEmailBody(
      integrationID: $integrationID
      remoteID: $remoteID
    ) {
      ...integrationEmailBodyFragment
    }
  }
  ${integrationEmailBodyFragment}
`;
